import merge from 'lodash-es/merge';
import useDefaultChartOptions from '@/components/charts/useDefaultChartOptions';
import usePieChartOptions from '@/components/charts/usePieChartOptions';
import { roundIfNecessary } from '@/util/helpers/numbers';
import { AllFilterSelectors, CourseStatistics, Region, UnknownFilterSelectors } from '@/types';

export const getEndedEventsRegionsConfig = (id: string, group: number, regions: Region[] | null, endedCourseStatistics: CourseStatistics[]) => {
    return {
        id,
        group,
        printTitle: 'Kommunefordeling (afsluttede forløb)',
        options: merge(useDefaultChartOptions(), usePieChartOptions(), {
            title: { text: 'Kommunefordeling' },
            series: {
                tooltip: {
                    pointFormatter() {
                        return `<span style="color:${(this as any).color}">●</span> Antal: <b>${(this as any).y}</b><br/><span style="color:${(this as any).color}">●</span> Fordeling: <b>${roundIfNecessary(
                            (this as any).percentage,
                            1
                        )}%</b><br/><span style="color:${(this as any).color}">●</span> Rangering: <b>${(this as any).index + 1}</b><br/>`;
                    },
                },
                data:
                    regions
                        ?.filter((currentRegion) => currentRegion.id !== AllFilterSelectors.AllRegions && currentRegion.id !== UnknownFilterSelectors.UnknownRegion)
                        ?.map((currentRegion) => {
                            return {
                                name: currentRegion.title,
                                y: endedCourseStatistics.filter((currentCourseStatistic) => currentCourseStatistic.region === currentRegion.id).length,
                            };
                        })
                        .filter((currentRegion) => currentRegion.y > 0)
                        .concat([{ name: 'Ikke oplyst', y: endedCourseStatistics.filter((currentCourseStatistic) => !currentCourseStatistic.region).length }])
                        .sort((a, b) => b.y - a.y)
                        .map((currentRegion, currentIndex) => {
                            return {
                                ...currentRegion,
                                dataLabels: {
                                    enabled: currentIndex < 10,
                                },
                            };
                        }) || [],
            },
        }),
    };
};
